import script from "./BaseStringSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseStringSelection.vue?vue&type=script&setup=true&lang=ts"

import "./BaseStringSelection.vue?vue&type=style&index=0&id=05061e36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05061e36"]])

export default __exports__